import { useState } from 'react';
import pharmacy from 'services/pharmacy';
import { SET_ERROR_MESSAGE } from 'helpers/types';
import { useDispatch } from 'react-redux';

export default () => {
  const [postcodesPharmacy, setPostcodesPharmacy] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch();

  const getPostcodePharmacy = async (postcode, numarkOnly, rowlands_only) => {
    try {
      const response = await pharmacy.get(`/pharmacies/postcode/${postcode}`, {
        params: {
          numark_only: numarkOnly,
          rowlands_only: rowlands_only
        },
      });
      if (response.data.length === 0) {
        setErrorMessage("Sorry we could not find a pharmacy near that postcode, try another postcode.");
      } else {
        setPostcodesPharmacy(response.data);
        setErrorMessage("");
      }
    } catch (e) {
      if (e.response.status === 404)
        dispatch({
          type: SET_ERROR_MESSAGE,
          payload: {
            msg: 'No address found, please try again',
            newMessage: true,
            link: '/pharmacy/dashboard/find-pharmacy',
            ctaText: 'Back to pharmacy search',
          },
        });
      throw e;
    }
  };

  return [postcodesPharmacy, getPostcodePharmacy, errorMessage];
};
